module.exports = __webpack_public_path__ + "img/ic_kr.a6699daf.svg";